import './style.scss';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { ChangePasswordProps, useChangePassword } from './hooks';
import { PasswordInput } from 'views/components/atoms/passwordInput';
import { Toast } from 'views/components/atoms/toast';

export const ChangePassword = () => {
  return (
    <section className="changePassword">
      <PageLocationSP />
      <div className="changePassword_form">
        <ChangePasswordBody isModal={false} />
      </div>
    </section>
  );
};

export const ChangePasswordBody = (props: ChangePasswordProps) => {
  const { formik, toastProps } = useChangePassword(props);

  return (
    <div className="changePasswordWrapper">
      <div className="changePasswordInput">
        <div className="changePasswordInput_label">現在のパスワード</div>
        <PasswordInput
          name="currentPassword"
          value={formik.values.currentPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder=""
        />
        <div className="errorRed">
          {formik.touched.currentPassword && formik.errors.currentPassword && formik.errors.currentPassword}
        </div>
      </div>

      <div className="changePasswordInput">
        <div className="changePasswordInput_label">新しいパスワード</div>
        <PasswordInput
          name="newPassword"
          value={formik.values.newPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <span className="changePasswordInput_label">
          パスワードは半角英字と数字をどちらも含む、8文字以上64文字以下の英数字記号でご設定ください
        </span>
        <span className="errorRed">
          {formik.touched.newPassword && formik.errors.newPassword && formik.errors.newPassword}
        </span>
      </div>

      <div className="changePasswordInput">
        <div className="changePasswordInput_label">新しいパスワード（確認用）</div>
        <PasswordInput
          name="confirmPassword"
          value={formik.values.confirmPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <span className="changePasswordInput_label">
          パスワードは半角英字と数字をどちらも含む、8文字以上64文字以下の英数字記号でご設定ください
        </span>
        <span className="errorRed">
          {formik.touched.confirmPassword && formik.errors.confirmPassword && formik.errors.confirmPassword}
        </span>
      </div>

      <div className="buttonWrapper">
        <Button
          label="パスワードを変更"
          type={ButtonType.Button}
          fillType={FillType.primaryFill}
          buttonSize={ButtonSize.sizeM}
          onClick={formik.handleSubmit}
        />
      </div>
      <Toast {...toastProps} />
    </div>
  );
};
